export { getRankingInformation } from './getRankingInformation';
export type { TemplateInstanceWithRank as TemplateWithRank } from './types';
